<div class="d-inline-block">
  <div class="lead item-list-title dont-break-out text-info">{{object.display}}</div>
  <div *ngIf="uri"><a target="_blank" [href]="uri.value">{{uri.value}}</a></div>
  <div *ngIf="issued || contributors?.length" data-test="issued-contributor" class="d-flex align-items-center text-muted">
    <span *ngIf="issued" data-test="issued" class="item-list-date">({{issued.value | date: 'YYYY-MM-dd'}})&nbsp;</span>
    <ds-truncatable *ngIf="contributors?.length" [id]="object.id">
      <ds-truncatable-part [id]="object.id" [minLines]="1">
        <span *ngFor="let contributor of contributors; let last=last;" data-test="contributors" class="item-list-authors">
          {{contributor.value}}<span *ngIf="!last">; </span>
        </span>
      </ds-truncatable-part>
    </ds-truncatable>
  </div>
  <div *ngIf="abstract" data-test="abstract" class="item-list-abstract">
    <ds-truncatable [id]="object.id">
      <ds-truncatable-part [id]="object.id" [minLines]="3">
        <span>{{abstract.value}}</span>
      </ds-truncatable-part>
    </ds-truncatable>
  </div>
  <div *ngIf="identifiers?.length" data-test="identifiers" class="text-muted">
    <ds-truncatable [id]="object.id">
      <ds-truncatable-part [id]="object.id" [minLines]="1">
        <span *ngFor="let identifier of identifiers; let last=last">
          {{identifier.value}}<span *ngIf="!last">; </span>
        </span>
      </ds-truncatable-part>
    </ds-truncatable>
  </div>
  <div *ngIf="object?.matchObjects?.length > 0">
    <p>
      <button type="button" class="btn btn-link p-0" (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed">
        <span class="badge badge-secondary">
          {{ object.matchObjects.length }}
        </span>
        {{'submission.sections.external-source.duplicate-matches.header' | translate}}
      </button>
    </p>
    <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" [id]="object.id">
      <div class="card p-1">
        <ng-container
          *ngFor="let match of object.matchObjects | slice: (pageConfig.currentPage-1) * pageConfig.pageSize : pageConfig.currentPage * pageConfig.pageSize">
          <ds-item-list-preview [item]="match"
                                [object]="$any(itemPreviewObject)"
                                [metadataList]="metadataList"
                                [showLabel]="showLabel"
                                [showMetrics]="showMetrics"
                                [showThumbnails]="showThumbnails"
                                [showCorrection]="showCorrection">
          </ds-item-list-preview>
          <div class="offset-2">
            <a class="btn btn-primary mt-1" ngbTooltip="{{'submission.workflow.generic.view-help' | translate}}"
              [routerLink]="getItemRoute(match)" target="_blank">
              <i class="fa fa-info-circle"></i> {{"submission.workflow.generic.view" | translate}}
            </a>
          </div>
          <hr>
        </ng-container>
        <div class="d-flex justify-content-center">
          <ngb-pagination [(page)]="pageConfig.currentPage" [pageSize]="pageConfig.pageSize"
            [collectionSize]="object.matchObjects.length">
          </ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
